import { Deserializable } from '../protocols/deserializable';
import { Attachment } from './attachment';

export class ConsentWaiverAttachment implements Deserializable {
  public id!: string;
  public attachment!: Attachment;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.attachment) {
      this.attachment = Deserialize.instanceOf(Attachment, this.attachment);
    }
  }
}
